import { Avatar, Box, Typography } from '@mui/material'
import IconDropdown from '../../components/IconDropdown'
import colors from '../../constants/colors'
import timeUtils from '../../utils/timeUtils'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import textUtils from '../../utils/textUtils'

export interface IUserRole {
  id?: number,
  value: string,
  label: string
}

export interface IUserProfileRole {
  text: string
}

export interface IUserProfile {
  reportAssingId: number
  access_role: string
  case_role: string
  roles: IUserProfileRole[]
  created_at: string
  id: number
  profile_pic: string
  title: string
  user: {
    email: string
    first_name: string
    last_name: string
    id: number
    last_login: string
    type: string
    username: string
    is_active: boolean
    date_joined: string
  }
}

const usersPageMainBoxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '3rem',
  height: '66vh',
  width: { xs: '80vw', lg: '64vw' },
}

const usersPageActionsBox = {
  display: 'flex',
  flexDirection: { xs: ' column', md: 'row' },
  justifyContent: 'center',
  alignItems: { md: 'end' },
  gap: '3rem',
  width: '100%',
}

const getColumns = (
  resetPassword: any,
  copyTextToClipboard: any,
  userDeactivation: any,
  editUserInfo: any,
) => [
  {
    id: 'user.username',
    label: 'Name',
    format: (value: string, row: IUserProfile) => {
      return (
        <Box sx={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
          <Avatar src={row?.profile_pic} />
          <Typography variant='labelBold' sx={{ textTransform: 'capitalize' }}>
            {row?.user.first_name} {row?.user.last_name}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'user.email',
    label: 'Email',
    format: (value: string, row: IUserProfile) => {
      return (
        <Box>
          <Typography variant='labelRegular' color={colors.BLACK}>
            {row?.user.email}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'user.role',
    label: 'Role',
    format: (value: string, row: IUserProfile) => {
      const renderRoles = (roles: { text: string }[]) => {
        let rolesString = ''
        roles?.forEach((role, index) => {
          rolesString = rolesString.concat(
            textUtils?.humanize(role?.text),
            `${index + 1 === roles?.length ? '' : ', '}`,
          )
        })
        return rolesString
      }
      return (
        <Box>
          <Typography variant='labelRegular' color={colors.BLACK}>
            {renderRoles(row?.roles as unknown as { text: string }[])}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'user.last_login',
    label: 'Last Log In',
    format: (value: string, row: IUserProfile) => {
      return (
        <Box>
          <Typography variant='labelRegular' color={colors.BLACK}>
            {timeUtils.calculateTimeAgo(row.user.last_login)}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'user.is_active',
    label: 'Status',
    format: (value: string, row: IUserProfile) => {
      return (
        <Box>
          <Typography variant='labelRegular' color={colors.BLACK}>
            {row?.user?.is_active ? 'Active' : 'Inactive'}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'actions',
    label: '',
    align: 'right',
    format: (value: any, row: IUserProfile) => {
      return (
        <IconDropdown
          containerSx={{ justifyContent: 'unset', margin: '0px !important' }}
          icon={<MoreVertIcon />}
          items={[
            {
              name: 'Edit User',
              onClick: () => {
                editUserInfo(row)
              },
            },
            {
              name: 'Reset password',
              onClick: () => {
                resetPassword(row?.user?.id)
              },
            },
            {
              name: 'Email user',
              onClick: () => {
                window.open(`mailto:${row?.user?.email}?subject=Subject&body=Body%20goes%20here`)
              },
            },
            {
              name: 'Copy Email Address',
              onClick: () => {
                copyTextToClipboard(row?.user?.email)
              },
            },
            {
              name: 'Deactivate user',
              onClick: () => {
                userDeactivation(row?.user?.id)
              },
            },
          ]}
        />
      )
    },
  },
]

export default {
  usersPageMainBoxStyle,
  usersPageActionsBox,
  getColumns,
}
